<template>
  <div class="history">
    <div class="head">
      <span class="title">История версий</span>
    </div>

    <div class="scroll">
      <div v-if="loading" class="state">
        <b-spinner small/>
      </div>

      <div v-else-if="!versions.length" class="state-empty">
        История пуста
      </div>

      <ul v-else class="list">
        <li
            v-for="v in versions"
            :key="v.id"
            :class="['item', { active: selectedId === v.id }]"
            @click="$emit('select', v)"
        >
          <span class="date">{{ formatDate(v.created_at) }}</span>
          <span class="author">
            {{ (v.updated_by && (v.updated_by.username || v.updated_by.email)) || '—' }}
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BusinessPromptHistory',
  props: {
    versions: { type: Array, default: () => [] },
    selectedId: { type: [Number, String], default: null },
    loading: { type: Boolean, default: false },
  },
  methods: {
    formatDate(iso) {
      if (!iso) return '';
      try {
        return new Date(iso).toLocaleString('ru-RU', { dateStyle: 'short', timeStyle: 'short' });
      } catch (e) {
        return iso;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.history {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.head {
  padding: 16px 16px 10px;
  border-bottom: 1px solid var(--ai-border);
}
.title {
  font-size: 11.5px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: .06em;
  color: var(--ai-text-muted);
}

.scroll {
  flex: 1;
  overflow-y: auto;
  padding: 4px 6px 12px;
}

.state {
  padding: 16px;
  display: flex;
  justify-content: center;
}
.state-empty {
  padding: 16px 14px;
  color: var(--ai-text-muted);
  font-size: 13px;
}

.list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.item {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px 10px;
  margin: 2px 4px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color .12s ease;

  .date {
    font-size: 13px;
    color: var(--ai-text);
    font-weight: 500;
  }
  .author {
    font-size: 11.5px;
    color: var(--ai-text-muted);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &:hover { background: var(--ai-sidebar-hover); }
  &.active { background: var(--ai-sidebar-active); }
}
</style>
